import actions from './actions';
import selectors from './selectors';
import reducers from './reducers';

export default {
  actions,
  selectors,
  reducers,
};
